/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from "react";
import { useSelector } from "react-redux";

import packageJson from "../../../../package.json";
import { selectEmail } from "../../../features/azure-b2c/storage/auth.slice";
import { MaintenancePage } from "../../../pages/Maintenance";
import { VersionMismatch } from "../../../pages/VersionMismatch";
import { compareVersions } from "../utils/compareVersions";

import { selectRemoteConfig } from "./remoteConfig.slice";

export const RemoteConfigStateMachine: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const config = useSelector(selectRemoteConfig);
  const loggedOnUserEmail = useSelector(selectEmail);

  const currentVersion = packageJson.version;

  const versionMismatch =
    !config.versionIsIgnored && !compareVersions(config.version, currentVersion);

  if (config.maintenance && !config.maintenanceParams.excludedUsers.includes(loggedOnUserEmail)) {
    return <MaintenancePage />;
  }

  if (versionMismatch) {
    return <VersionMismatch expected={config.version} current={currentVersion} />;
  }

  return children;
};
